import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView, View } from "@frui.ts/views";
import { observer, Observer } from "mobx-react-lite";
import PaymentsPairingViewModel from "viewModels/finance/paymentsPairing/paymentsPairingViewModel";
import Tabs from "../../common/tabs";

const PaymentsPairingView: ViewComponent<PaymentsPairingViewModel> = observer(({ vm }) => (
  <>
    {vm.showTabs ? (
      <>
        <h3 className="mb-4">{vm.name}</h3>
        <Tabs vm={vm} />
      </>
    ) : (
      <Observer>{() => <View vm={vm.activeChild} />}</Observer>
    )}
  </>
));

registerView(PaymentsPairingView, PaymentsPairingViewModel);
